import { logger } from '@automata/utils';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { SelectedWorkcellId } from './types';
import { WorkcellData } from '../../features/workflow/types';
import { workcellDataSchema } from '../../features/workflow/validation';

// NOTE(IL, 2024-08-30): This is a workaround until we get the workcell from its proper location (TBD)
export const useGetWorkcell = (
  workcellId: SelectedWorkcellId,
  options: UseQueryOptions<WorkcellData> = {}
) => {
  return useQuery({
    queryKey: ['workcell-temp', workcellId],
    queryFn: async () =>
      await fetch(`/api/canvas-temp/workcell-instruments/${workcellId}`).then(
        (res) => {
          if (!res.ok) {
            const error = new Error(
              `Problem fetching workcell "${workcellId}"`
            );
            logger.error(error);
            throw error;
          }
          return res.json();
        }
      ),
    select: workcellDataSchema.parse,
    ...options,
  });
};
